import React from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import UserActions from 'users/components/UserActions';
import { Form } from 'common/components';

const UserRow = ({
  companyId,
  handleToggle = () => {},
  isLoading = false,
  permissions,
  t,
  user,
}) => (
  <tr>
    <td>{user.email}</td>
    <td className="text-center">
      <div className="nowrap">
        <Form.Button
          text={t('actions.deactivate')}
          type={'button'}
          color={'secondary'}
          isLoading={isLoading}
          extraClassName={'btn-sm mr-2'}
          onClick={(e) => {
            e.preventDefault();
            handleToggle(user);
          }}
        />
      </div>
    </td>
  </tr>
);

export default translate()(UserRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/form/sections/NotificationHistoricFormUserToNotifyRow.js